var jCube = require('./core'),
    vars = require('./variables');

jCube.h.initContainers = function() {
    if (jCube._containers) return;
    var table = vars.doc.createElement('table'),
        tr = vars.doc.createElement('tr');
    jCube._containers = {
        '*': vars.div,
        tr: vars.doc.createElement('tbody'),
        td: tr,
        th: tr,
        thead: table,
        tbody: table,
        tfoot: table
    };
};

jCube.h.getEventNameBubbling = function(name) {
    return vars.eventsHover[name] || vars.eventsFocus[name] || name;
};

jCube.h.getSplitValues = function (str) {
    return jCube.isString(str) ? str.match(vars.splitValuesRe) || [] : [];
};

jCube.h.getEventsCache = function(ele) {
    return ele[vars.eventsNamespace] = ele[vars.eventsNamespace] || {};
};

jCube.h.hasNamespaces = function(ns1, ns2) {
    return !ns2 || !vars.some.call(ns2, function (ns) {
        return ns1.indexOf(ns) < 0;
    });
};

jCube.h.addEvent = function(ele, name, namespaces, selector, callback) {
    callback.guid = callback.guid || jCube.guid++;
    var eventCache = jCube.h.getEventsCache(ele);
    eventCache[name] = eventCache[name] || [];
    eventCache[name].push([namespaces, selector, callback]);
    ele.addEventListener(name, callback);
};

jCube.h.parseEventName = function(eventName) {
    var parts = eventName.split(vars.eventsNamespacesSeparator);
    return [parts[0], parts.slice(1).sort()]; // [name, namespace[]]
};

jCube.h.removeEvent = function(ele, name, namespaces, selector, callback) {
    var cache = jCube.h.getEventsCache(ele);

    if (!name) {
        for (name in cache) {
            jCube.h.removeEvent(ele, name, namespaces, selector, callback);
        }

        delete ele[vars.eventsNamespace];
    } else if (cache[name]) {
        cache[name] = cache[name].filter(function (_a) {
            var ns = _a[0],
                sel = _a[1],
                cb = _a[2];
            if (callback && cb.guid !== callback.guid || !jCube.h.hasNamespaces(ns, namespaces) || selector && selector !== sel) return true;
            ele.removeEventListener(name, cb);
        });
    }
};

jCube.h.unique = function(arr) {
    return arr.length > 1 ? vars.filter.call(arr, function (item, index, self) {
        return vars.indexOf.call(self, item) === index;
    }) : arr;
};

jCube.h.matches = function(ele, selector) {
    var matches = ele && (ele['matches'] || ele['webkitMatchesSelector'] || ele['mozMatchesSelector'] || ele['msMatchesSelector'] || ele['oMatchesSelector']);
    return !!matches && matches.call(ele, selector);
};

jCube.h.pluck = function(arr, prop, deep) {
    var plucked = [];

    for (var i = 0, l = arr.length; i < l; i++) {
        var val_1 = arr[i][prop];

        while (val_1 != null) {
            plucked.push(val_1);
            if (!deep) break;
            val_1 = val_1[prop];
        }
    }

    return plucked;
};

jCube.h.filtered = function(collection, comparator) {
    return !comparator || !collection.length ? collection : collection.filter(comparator);
};

jCube.h.insertElement = function(anchor, child, prepend, prependTarget) {
    if (prepend) {
        anchor.insertBefore(child, prependTarget);
    } else {
        anchor.appendChild(child);
    }

    // this.evalScripts(child); // TODO: deleted by Mirko
};

jCube.h.insertContent = function(parent, child, prepend) {
        var _this = this;
        jCube.each(parent, function (index, parentEle) {
            jCube.each(child, function (i, childEle) {
                jCube.h.insertElement(parentEle, !index ? childEle : childEle.cloneNode(true), prepend, prepend && parentEle.firstChild);
            });
        });
    };
// };

// module.exports = jCube.h.;